import { Link } from 'react-router-dom';

import { DEFAULT_PATH } from '../app/screens';

import './screens.css';

/** Catch-all screen, rendered inside the shell so the nav stays available. */
export function NotFoundScreen(): React.JSX.Element {
  return (
    <section className="screen" aria-label="Page not found">
      <div className="screen-card screen-card-centred">
        <p className="screen-card-badge" aria-hidden="true">
          404
        </p>
        <p className="screen-card-body">
          That route does not exist in Docsight. It may have been renamed, or the link may be
          truncated.
        </p>
        <Link className="screen-cta" to={DEFAULT_PATH}>
          Back to the dashboard
        </Link>
      </div>
    </section>
  );
}
